import React from "react";
import { HeaderAction, HeaderComponent } from "../../types";
import { renderIcon } from "../../utils/icons";

interface ComponentsPanelProps {
	dispatch: React.Dispatch<HeaderAction>;
}

const ComponentsPanel: React.FC<ComponentsPanelProps> = ({ dispatch }) => {
	const handleAddComponent = (type: string) => {
		const newComponent: HeaderComponent = {
			id: `${type}-${Date.now()}`,
			type: type as any,
			settings: getDefaultSettings(type),
			styles: {},
		};

		dispatch({
			type: "ADD_COMPONENT",
			payload: newComponent,
		});
	};

	const getDefaultSettings = (type: string) => {
		switch (type) {
			case "logo":
				return {
					size: "M",
					image: "/api/placeholder/120/40",
					link: "/",
				};
			case "searchBar":
				return {
					size: "full",
					placeholder: "Search...",
					icon: "search",
				};
			case "wishlist":
				return {
					size: "M",
					type: "button",
					icon: "heart",
				};
			case "cart":
				return {
					size: "M",
					type: "button",
					icon: "cart",
				};
			case "user":
				return {
					size: "M",
					type: "button",
					icon: "user",
				};
			case "menu":
				return {
					size: "M",
					type: "button",
					icon: "menu",
				};
			case "navItems":
				return {
					items: [
						{
							id: `nav-item-${Date.now()}-1`,
							text: "Home",
							link: "/",
						},
						{
							id: `nav-item-${Date.now()}-2`,
							text: "Products",
							link: "/products",
						},
					],
				};
			default:
				return {};
		}
	};

	return (
		<div className="p-4">
			<h3 className="text-lg font-medium mb-4">Available Components</h3>

			<div className="grid grid-cols-2 gap-4">
				<button
					className="p-4 flex flex-col items-center border rounded hover:bg-gray-50"
					onClick={() => handleAddComponent("logo")}>
					<div className="mb-2">{renderIcon("image")}</div>
					<span>Logo</span>
				</button>

				<button
					className="p-4 flex flex-col items-center border rounded hover:bg-gray-50"
					onClick={() => handleAddComponent("searchBar")}>
					<div className="mb-2">{renderIcon("search")}</div>
					<span>Search</span>
				</button>

				<button
					className="p-4 flex flex-col items-center border rounded hover:bg-gray-50"
					onClick={() => handleAddComponent("wishlist")}>
					<div className="mb-2">{renderIcon("heart")}</div>
					<span>Wishlist</span>
				</button>

				<button
					className="p-4 flex flex-col items-center border rounded hover:bg-gray-50"
					onClick={() => handleAddComponent("cart")}>
					<div className="mb-2">{renderIcon("cart")}</div>
					<span>Cart</span>
				</button>

				<button
					className="p-4 flex flex-col items-center border rounded hover:bg-gray-50"
					onClick={() => handleAddComponent("user")}>
					<div className="mb-2">{renderIcon("user")}</div>
					<span>User</span>
				</button>

				<button
					className="p-4 flex flex-col items-center border rounded hover:bg-gray-50"
					onClick={() => handleAddComponent("navItems")}>
					<div className="mb-2">{renderIcon("menu")}</div>
					<span>Navigation</span>
				</button>
			</div>
		</div>
	);
};

export default ComponentsPanel;
